import axios from 'axios';
import * as Sentry from '@sentry/browser';
import { Comment, CommentsPayload } from './Comment';

const API_URL =
  process.env.REACT_APP_WORDPRESS_API_DOMAIN + '/wp-json/wp/v2/comments';

const handleError = (error: any) => {
  // console.log(JSON.stringify(error));
  if (error.isAxiosError && error.response && error.response.data) {
    const errorMessage = `error code: ${JSON.stringify(
      error.response.data
    )}, status: ${error.response.status}`;
    Sentry.captureMessage(errorMessage, Sentry.Severity.Error);
  }
  Sentry.captureException(error);
  throw error;
};

export const getComments = async () => {
  let pageIndex = 1;
  const commentUrl = API_URL + '?order=asc&per_page=100&page=';
  try {
    let result = await axios.get(commentUrl + pageIndex);

    const testimonialPostId = process.env.REACT_APP_TESTIMONIAL_POST_ID || '9';
    const signaturePostId = process.env.REACT_APP_SIGNATURE_POST_ID || '10';

    let totalData = result.data;
    const totalPageCount: number = parseInt(result.headers['x-wp-totalpages']);

    for (let i = 2; i <= totalPageCount; i++) {
      result = await axios.get(commentUrl + i);
      totalData = [...totalData, ...result.data];
    }

    const testimonials: Comment[] = totalData.filter((comment: Comment) => {
      return comment.post === parseInt(testimonialPostId);
    });

    const signatures: Comment[] = totalData.filter((comment: Comment) => {
      return comment.post === parseInt(signaturePostId);
    });

    return { testimonials, signatures } as CommentsPayload;
  } catch (error) {
    handleError(error);
  }
};

export const saveTestimonial = async (testimonial: string) => {
  try {
    // Send a POST request
    const postId = process.env.REACT_APP_TESTIMONIAL_POST_ID || '9';
    const result = await axios.post(
      API_URL,
      {
        author_name: 'Story Submission',
        author_email: 'story@thankyoudoctors.ca',
        content: testimonial,
        post: parseInt(postId),
      },
      {}
    );

    return result;
  } catch (error) {
    handleError(error);
  }
};

export const saveSignature = async (name: string, signatureStyle: string) => {
  try {
    const signaturePostId = process.env.REACT_APP_SIGNATURE_POST_ID || '10';
    const result = await axios.post(API_URL, {
      author_name: name,
      author_email: 'signature@thankyoudoctors.ca',
      content: signatureStyle,
      post: parseInt(signaturePostId),
    });
    return result;
  } catch (error) {
    handleError(error);
  }
};
